import { Box, Image } from '@chakra-ui/react';
import SleepGnocco from '../styles/images/gnocco-sleep.png';


export default function SleepingMascotImage() {
  return (
    <Box py='2em' >
      <Image boxShadow='xs' rounded='2em' w='36em' src={SleepGnocco} draggable="false" alt="unexpected error sleeping gnocco" />
    </Box>
  )
}
